import { ApClassTypesDTO } from "../dto/classes/ApClassTypesDTO";
import { ApClassType } from "../models/Classes/ApClassType";

export const apClassTypesMapper = (dto: ApClassTypesDTO) => {
  return new ApClassType({
    id: dto.typeId,
    name: dto.typeName,
    ratingPrereq: dto.ratingPrereq,
    classPrereq: dto.classPrereq,
    ratingOverkill: dto.ratingOverkill,
  });
};
